import React, { useCallback, useState } from "react";
import { DA_Button } from "@danishagro/shared/src/components/atoms/Button/Button.component";
import { DA_Modal } from "@danishagro/shared/src/components/molecules/Modal/Modal.component";
import { useModal } from "@danishagro/shared/src/contexts/modal.context";
import { DA_Checkbox } from "@danishagro/shared/src/components/atoms/Checkbox/Checkbox.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { usePrivacyPolicyApi } from "@hooks/api/usePrivacyPolicyApi.hook";
import S from "./PrivacyModal.module.scss";

export interface DA_PrivacyModalProps {
    title?: string;
}

export const DA_PrivacyModal = (_props: DA_PrivacyModalProps) => {
    const [awaitingResponse, setAwaitingResponse] = useState(false);
    const [privacyAccepted, setPrivacyAccepted] = useState<boolean>(false);
    const { getDictionaryString } = useTranslations();
    const { closeModal } = useModal();
    const { acceptPrivatePolicy } = usePrivacyPolicyApi();

    const onSubmitButtonClicked = useCallback(() => {
        setAwaitingResponse(true);

        acceptPrivatePolicy()
            .then(() => {
                // Minimal fetch request to clear user cache
                fetch("/clearusercache").catch((error) =>
                    console.error("Error clearing user cache:", error)
                );
            })
            .catch((error) => {
                console.error("Error accepting privacy policy:", error);
            })
            .finally(() => {
                setAwaitingResponse(false);
                closeModal();
                console.log("called");
            });
    }, [closeModal, acceptPrivatePolicy]);

    return (
        <DA_Modal hideCloseButton title={getDictionaryString("PrivacyModalTitle")}>
            <section>
                <DA_Checkbox
                    name="privacyAccepted"
                    checked={privacyAccepted}
                    value=""
                    onChange={setPrivacyAccepted}
                    label={
                        <span>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: getDictionaryString("PrivacyModalLabel"),
                                }}
                            />{" "}
                            <a
                                title={getDictionaryString("PrivacyModalLinkTitle")}
                                href={getDictionaryString("PrivacyModalLink")}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {getDictionaryString("PrivacyModalLinkText")}
                            </a>
                        </span>
                    }
                />

                <div className={S.buttons}>
                    {/** Submit */}
                    <DA_Button
                        title={getDictionaryString("confirm")}
                        onClick={onSubmitButtonClicked}
                        className={S.primaryButton}
                        disabled={!privacyAccepted}
                        showSpinner={awaitingResponse}
                    />
                </div>
            </section>
        </DA_Modal>
    );
};
